import React from 'react';
import PropTypes from 'prop-types';

const Title = ({ text }) => (
  <h1 className="ma0 mv3 f4 f3-ns">{text}</h1>
);

Title.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Title;
